<ul>
  @for (geometry of activeGeometries; track geometry) {
    <li>
      <rask-button
        (click)="click(geometry)"
        (mouseover)="mouseover(geometry)"
        (mouseout)="mouseout(geometry)"
      color="tertiary">{{geometry.label}}</rask-button>
    </li>
  }
</ul>